import type { SxProps, Theme } from '@mui/material';

import { EXPAND_TRANSITION_MS } from '../constants';

const transition = `all ${EXPAND_TRANSITION_MS}ms ease-in-out`;

export const rootSx: SxProps<Theme> = {
  display: 'inline-flex',
  flexDirection: 'column',
  gap: 1,
};

export const thumbsRowSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
};

export const thumbButtonSx = (selected: boolean): SxProps<Theme> => ({
  p: 0.5,
  transition,
  color: selected ? 'primary.main' : 'text.secondary',
  '&:hover': {
    color: 'primary.main',
  },
});

export const compactThumbButtonSx = (selected: boolean): SxProps<Theme> => ({
  p: 0.25,
  transition,
  color: selected ? 'primary.main' : 'text.secondary',
  '&:hover': {
    color: 'primary.main',
  },
  '& .MuiSvgIcon-root': { fontSize: '1rem' },
});

export const expansionSx = (open: boolean): SxProps<Theme> => ({
  overflow: 'hidden',
  maxHeight: open ? 500 : 0,
  opacity: open ? 1 : 0,
  transition,
});

export const categoriesRowSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0.5,
  mt: 0.5,
};

export const commentRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: 1,
  mt: 1,
};

export const popoverContentSx: SxProps<Theme> = {
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 320,
};

export const thanksSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  color: 'success.main',
};
